export const AutumnColors = Object.freeze({
  PUMPKIN: '#e8731a',
  PUMPKIN_DARK: '#c2520c',
  PUMPKIN_LIGHT: '#f59a4b',
  STEM: '#5b7a2a',
  LEAF_RED: '#b63a1e',
  LEAF_ORANGE: '#e07a1f',
  LEAF_YELLOW: '#e6b422',
  LEAF_GOLD_DARK: '#a8741a',
  LEAF_BROWN: '#8a5a2b',
  GLOW: '#ffd166',
  HEADER_TINT: '#fff9f2',
});

export const AUTUMN_GRADIENT = `linear-gradient(90deg, ${AutumnColors.LEAF_RED}, ${AutumnColors.PUMPKIN_DARK}, ${AutumnColors.LEAF_GOLD_DARK}, ${AutumnColors.LEAF_BROWN}, ${AutumnColors.LEAF_RED})`;
